(function () {
    'use strict';

    function searchFieldConfiguration() {

        return {
            restrict: 'E',
            templateUrl: 'common/directives/templates/searchFieldConfiguration.html',
            link: function (scope) {
            }
        };
    }

    searchFieldConfiguration.$inject = [];

    angular.module('ecap.common').directive('searchFieldConfiguration', searchFieldConfiguration);
})();
